module.exports = __webpack_public_path__ + "static/media/alastairSutton.1488d9bf.jpg";


//////////////////
// WEBPACK FOOTER
// ./public/maxsizeimages/authorSpotlight/alastairSutton.jpg
// module id = 1659
// module chunks = 1